import React from "react";
import {Form, Button, Alert} from "react-bootstrap";
import EmailValidator from "email-validator";
import {Link} from "react-router-dom";

class LoginForm extends React.Component{
    state = {
        data: {
            email: "",
            password: ""
        },
        errors:{},
        isSubmit: "no"
    };
    onchange = event => this.setState({
        data: {...this.state.data, [event.target.name] : event.target.value }
    });
    onsubmit = (e) => {
        e.preventDefault();
        var errors = this.validate(this.state.data);
        this.setState( {errors} );
        if (Object.keys(errors).length === 0) {
            this.setState({loading:true});
            this.props.submit(this.state.data).catch(msg=>{
                this.setState({loading: false})
                this.setState({errors:msg.response.data.err.errors});
        }).then(msg => {
            this.setState({loading: false})  
        });
        this.setState({ isSubmit: "yes"})
        }

    };

    showAndHidePassword = () => {
        const password = document.querySelector("#password");
        if(password.type==="password"){
            password.type="text";
        }else{
            password.type="password"; 
        }
    }

    validate = (data) => {
        const errors = {};
        if (EmailValidator.validate(data.email) === false) {errors.email = "Invalid email"};
        return errors; 
    }

    render(){
        const {email, password} = this.state.data;
        const {errors} = this.state;
        const {showAndHidePassword} = this;
        return(
            <div>
                { errors.global && <Alert variant = "danger" >
                        { errors.global} 
                    </Alert>
                }
                <Form className="ak3_form" noValidate  onSubmit = {this.onsubmit}>
                    <h1 className="text-center">Login Form </h1>
                    <h5 className="danger">{errors.email}</h5>
                    <Form.Group controlId="email">
                        <Form.Label className="form-lab"
                        >Email address</Form.Label>
                        <Form.Control 
                            type="email" 
                            required 
                            placeholder="example@example.com"
                            name = "email"
                            value = {email}
                            onChange = {this.onchange}
                            className="bg-clickable" 
                        />
                    </Form.Group>
                    <Form.Group controlId="password">
                        <Form.Label className="form-lab">Password</Form.Label>
                        <Form.Control 
                            type="password" 
                            required 
                            placeholder="Make it secure" 
                            name = "password"
                            value = {password}
                            onChange = {this.onchange}
                            className="bg-clickable"
                        />
                    <div className="showHidePasswordContainer">
                        <input type="checkbox" id="showPassword" onClick={showAndHidePassword}/>
                        <label for="showPassword" type="button" className="showHidePassword">Show Password</label>
                    </div>
                    </Form.Group>

                    <Link className="text-dark" to="/forgot_password"> Forgot Password ? </Link><br />
                    <Link className="text-dark" to="/register"> New User? Register Now </Link>
                    <Button variant="success" className="ml-ak3" type = "submit">Login</Button>
                </Form>
                    {this.state.loading && (
                    <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    )}
            </div>
        );
    };
};

export default LoginForm;